<template>
    <v-layout row wrap :class="listClass">
        <v-flex v-for="product in products" :class="[itemClass]" :key="product.id">
            <product-thumbnail :product="product"/>
        </v-flex>
    </v-layout>
</template>

<script>
    import {Observable} from 'rxjs';
    import {getProducts} from './store/getProducts';

    export default {
        name: 'ProductsList',
        props: {
            ids: Array,
            itemClass: {
                type: String,
                default: 'xs12 sm6 md4',
            },
            listClass: String,
        },
        data() {
            return {
                products: [],
                productsSubscriber: null,
            };
        },
        created() {
            this.productsSubscriber = getProducts(new Observable(subscriber => this.$watch(
                'ids',
                (ids) => {
                    subscriber.next({
                        ids,
                    });
                },
                {
                    immediate: true,
                }
            )))
            .subscribe(products => this.products = products);
        },
        beforeDestroy() {
            this.productsSubscriber.unsubscribe();
        },
    };
</script>